<template>
  <SogCard>
    <SogCardTitle>
      Ausfuhrformulare
      <template #SubTitle>
        Wählen Sie vorhandene Ausfuhrformulare aus
      </template>
    </SogCardTitle>
    <SogCardContent v-show="_loadStoreExportBlank">
      <SogSkeleton
        v-for="index in 5"
        :key="index"
        height="48px"
      />
    </SogCardContent>
    <SogCardActions
      v-show="!_loadStoreExportBlank"
      :is-toolbar="true"
    >
      <SogBadge
        v-show="_exportBlanksCount > 0"
        :value="_exportBlanksCount"
        badge-style="primary"
        badge-type="notification"
        overlap="true"
      >
        <SogCardActionButton
          v-show="_current.shoppingCartItem.insuranceExportBlanks.length > 0"
          mdi-icon="mdi-cart-arrow-down"
          tooltip="In den Einkaufswagen legen"
          @click="onAddStoreExportBlanks"
        />
      </SogBadge>
      <SogCardActionButton
        v-show="_manuellVisible"
        mdi-icon="mdi-form-textbox"
        tooltip="Manuel angeben"
        @click="onExportBlank"
      />
      <SogTextBox
        v-model="_exportBlankSearch"
        placeholder="Nummer"
        width="150px"
        :interval-modified="loadStoreExportBlank"
        style="padding-left: 5px"
      />
      <SogCardActionButton
        :kind="SogButtonKind.Search"
        @click="loadStoreExportBlank"
      />
    </SogCardActions>
    <SogCardContent v-show="!_loadStoreExportBlank">
      <SelectExportBlanksComponent :export-blanks="_storeExportBlank" />
    </SogCardContent>
  </SogCard>
</template>

<script setup lang="ts">

import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogSkeleton from "@/shared/ui/SogSkeleton.vue";
import SogBadge from "@/shared/ui/SogBadge.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SelectExportBlanksComponent from "@/modules/ShoppingCart/components/SelectExportBlanksComponent.vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import {storeToRefs} from "pinia";
import {computed, ref, watch} from "vue";
import {useSpinner} from "@/shared/composables/SogSpinner";
import apiStore from "@/modules/Store/api";
import InsuranceExportBlank, {
  InsuranceExportBlankStatus,
  sortInsuranceExportBlank
} from "@/shared/model/InsuranceExportBlank";
import {useAccountStore} from "@/stores/accountStore";


const _shoppingCartStore = useShoppingCartStore();
const _accountStore = useAccountStore();
const {currentItem: _current} = storeToRefs(_shoppingCartStore);

const _spinner = useSpinner();

const _loadStoreExportBlank = ref(false);
watch(_loadStoreExportBlank, (value) => {
  if (value) {
    _spinner.show();
  } else {
    _spinner.hide();
  }
});
const _exportBlanksCount = computed(() => {
  return _current.value.shoppingCartItem.insuranceExportBlanks.length;
});
const _exportBlankSearch = ref("");
const _storeExportBlank = ref<InsuranceExportBlank[]>([]);


const _manuellVisible = computed(() => {
    return _current.value.shoppingCartItem.productPrice?.productTypeId === "ExportBlank" ||
        _current.value.shoppingCartItem.productPrice?.productTypeId === "Zoll" && _accountStore.hasExportBlankProduct
  }
)

async function loadStoreExportBlank() {
  _loadStoreExportBlank.value = true;
  try {
    _storeExportBlank.value = [];
    const lst = await apiStore.listInsuranceExportBlank(
      false,
      _exportBlankSearch.value
    );
    if (lst) {
      _storeExportBlank.value = sortInsuranceExportBlank(
        lst.filter(
          (t) =>
            t.status !== InsuranceExportBlankStatus.IncorrectlyFilled &&
            !_current.value.shoppingCartItem.insuranceExportBlanks.some(
              (a) => a.id === t.id
            )
        )
      );
    }
  } finally {
    _loadStoreExportBlank.value = false;
  }
}

async function onAddStoreExportBlanks() {
  await _shoppingCartStore.addStoreExportBlanks();
}

async function onExportBlank() {
  await _shoppingCartStore.navigate("exportblank");
}

defineExpose({loadStoreExportBlank})

</script>

<style scoped>

</style>
